import UserRole from '@sone/sone-frontend-core/src/models/UserRole';

export class UserInfoModel {
  public company!: string;
  public name!: string;
  public nickname!: string;
  public owner!: string | boolean;
  public roles!: string | UserRole[];
  public sub!: string;
  public subject!: string;
  public userId!: string;
}
